module.exports = __webpack_public_path__ + "img/xia.1316d79d.svg";